module.exports = __webpack_public_path__ + "static/pic02-16cdd34b7010336029bba589e6a8a68a.jpg";